import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import { Link } from "react-router-dom";
import './home.css';

// import Timer from "../widget/timer";
import org_1 from '../../image/home/partners_logos/logos_squares_ORG_EMSD.png';
import org_2 from '../../image/home/partners_logos/logos_squares_ORG_GPAST.png';
import coorg_1 from '../../image/home/partners_logos/logos_squares_CoOrg_Cyberport.png';
import coorg_2 from '../../image/home/partners_logos/logos_squares_CoOrg_HKSTP.png';
import coorg_2_sc from '../../image/home/partners_logos/logos_squares_CoOrg_HKSTP_SC.png';
import adv_1 from '../../image/home/partners_logos/logos_squares_Adv_DEVB.png';
import adv_2 from '../../image/home/partners_logos/logos_squares_Adv_EEB.png';
import adv_3 from '../../image/home/partners_logos/logos_squares_Adv_ITIB.png';
import sup_1 from '../../image/home/partners_logos/logos_squares_Sup_ASD.png';
import sup_2 from '../../image/home/partners_logos/logos_squares_Sup_ASHRAE.png';
import sup_3 from '../../image/home/partners_logos/logos_squares_Sup_BEAM.png';
import sup_4 from '../../image/home/partners_logos/logos_squares_Sup_BSOMES.png';
import sup_5 from '../../image/home/partners_logos/logos_squares_Sup_BTRI.png';
import sup_6 from '../../image/home/partners_logos/logos_squares_Sup_BEC.png';
import sup_7 from '../../image/home/partners_logos/logos_squares_Sup_CEDD.png';
import sup_9 from '../../image/home/partners_logos/logos_squares_Sup_DPO.png';
import sup_10 from '../../image/home/partners_logos/logos_squares_Sup_DSD.png';
import sup_11 from '../../image/home/partners_logos/logos_squares_Sup_EIHK.png';
import sup_12 from '../../image/home/partners_logos/logos_squares_Sup_HyD.png';
import sup_13 from '../../image/home/partners_logos/logos_squares_Sup_HKABAEIMA.png';
import sup_14 from '../../image/home/partners_logos/logos_squares_Sup_HKBU_AESC.png';
import sup_15 from '../../image/home/partners_logos/logos_squares_Sup_HKCS.png';
import sup_16 from '../../image/home/partners_logos/logos_squares_Sup_HKGBC.png';
import sup_17 from '../../image/home/partners_logos/logos_squares_Sup_IOTA.png';
import sup_18 from '../../image/home/partners_logos/logos_squares_Sup_HKPC.png';
import sup_19 from '../../image/home/partners_logos/logos_squares_Sup_LSCM.png';
import sup_20 from '../../image/home/partners_logos/logos_squares_Sup_SCC.png';
import sup_21 from '../../image/home/partners_logos/logos_squares_Sup_CIBSE.png';
import sup_22 from '../../image/home/partners_logos/logos_squares_Sup_HKFEMC.png';
import sup_23 from '../../image/home/partners_logos/logos_squares_Sup_HKIEBSD.png';
import sup_24 from '../../image/home/partners_logos/logos_squares_Sup_HKIEED.png';
import sup_25 from '../../image/home/partners_logos/logos_squares_Sup_HKIEGED.png';
import sup_26 from '../../image/home/partners_logos/logos_squares_Sup_HKIEITD.png';
import sup_27 from '../../image/home/partners_logos/logos_squares_Sup_HKIE_YMC.png';
import sup_28 from '../../image/home/partners_logos/logos_squares_Sup_HKPU.png';
import sup_29 from '../../image/home/partners_logos/logos_squares_Sup_HKUST.png';
import sup_30 from '../../image/home/partners_logos/logos_squares_Sup_WSD.png';
import sup_8 from '../../image/home/partners_logos/logos_squares_Sup_CIC.png';
import tit_1 from '../../image/home/partners_logos/logos_squares_Titanium_Huawei.png';
import dia_1 from '../../image/home/partners_logos/logos_squares_Diamond_Alibaba.png';
import dia_2 from '../../image/home/partners_logos/logos_squares_Diamond_ATAL.png';
import dia_3 from '../../image/home/partners_logos/logos_squares_Diamond_ANLEV.png';
import dia_4 from '../../image/home/partners_logos/logos_squares_Diamond_Siemens.png';
import dia_5 from '../../image/home/partners_logos/logos_squares_Diamond_Towngas.png';
import dia_6 from '../../image/home/partners_logos/logos_squares_Diamond_Yordland.png';
import gold_1 from '../../image/home/partners_logos/logos_squares_Gold_AECOM.png';
import gold_2 from '../../image/home/partners_logos/logos_squares_Gold_Alliance.png';
import gold_3 from '../../image/home/partners_logos/logos_squares_Gold_CHEVALIER.png';
import gold_4 from '../../image/home/partners_logos/logos_squares_Gold_DELTA.png';
import gold_5 from '../../image/home/partners_logos/logos_squares_Gold_KONE.png';
import gold_6 from '../../image/home/partners_logos/logos_squares_Gold_Midea.png';
import gold_7 from '../../image/home/partners_logos/logos_squares_Gold_Sensetime.png';
import gold_8 from '../../image/home/partners_logos/logos_squares_Gold_SHK.png';
import gold_9 from '../../image/home/partners_logos/logos_squares_Gold_JEC.png';
import plat_1 from '../../image/home/partners_logos/logos_squares_Platinum_CLP.png';
import plat_2 from '../../image/home/partners_logos/logos_squares_Platinum_HKE.png';
import plat_3 from '../../image/home/partners_logos/logos_squares_Platinum_MTR.png';
import plat_4 from '../../image/home/partners_logos/logos_squares_Platinum_REC.png';
import plat_5 from '../../image/home/partners_logos/logos_squares_Platinum_Tencent.png';


import Footer from "../layout/footer";

class Home extends Component {
  state = {
    topVideoUrl: "",
    topVideoUpdate: false,
    slided: false,
  }
  goToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "initial"
    });
  }
  updateTopVideo() {
    let width = window.innerWidth;
    let path = window.location.pathname
    path = path.slice(1, 3);

    if (width > 930) {
      if (path === 'en') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_1440.mp4" });
      } else if (path === 'sc') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_1440_sc.mp4" });
      } else if (path === 'tc') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_1440_tc.mp4" });
      }
    } else if (width > 480) {
      if (path === 'en') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_930.mp4" });
      } else if (path === 'sc') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_930_sc.mp4" });
      } else if (path === 'tc') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_930_tc.mp4" });
      }
    } else {
      if (path === 'en') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_480.mp4" });
      } else if (path === 'sc') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_480_sc.mp4" });
      } else if (path === 'tc') {
        this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/Video_480_tc.mp4" });
      }
    }
    document.getElementById('topVideo').loop = false;
    document.getElementById('topVideo').controls = true;
    document.getElementById('topVideo').muted = false;
    document.getElementById('topVideo').autoPlay = true;
    this.setState({ topVideoUpdate: true });

  }

  componentDidMount() {

    document.getElementById('topVideo').loop = true;
    document.getElementById('topVideo').muted = true;
    document.getElementById('topVideo').autoPlay = true;
    document.getElementById('topVideo').pause();

    let myModal = document.getElementById('myModal');
    let video = document.getElementById('video');

    myModal.addEventListener('hide.bs.modal', function () {
      video.setAttribute('src', '');
    });
    setInterval(() => {
      if (this.state.slided) {
      } else {
        let currentWidth = window.innerWidth;
        let currentPath = window.location.pathname;
        currentPath = currentPath.slice(4, -1);
        if (currentPath === "home" || currentPath === "hom") {
          document.getElementById('first_click').click();

          let path = window.location.pathname
          path = path.slice(1, 3);
          if (currentWidth > 480) {
            if (path === 'en') {
              this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/teaser_1440+930.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            } else if (path === 'sc') {
              this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/teaser_1440+930_sc.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            } else if (path === 'tc') {
              this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/teaser_1440+930_tc.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            }
          } else {
            if (path === 'en') {
              this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/teaser_480.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            } else if (path === 'sc') {
              this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/teaser_480_sc.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            } else if (path === 'tc') {
              this.setState({ topVideoUrl: "https://globalaichallenge.com/static/media/teaser_480_tc.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
            }
          }
          document.getElementById('topVideo').play();

          this.setState({ slided: true });
        }

      }
    }, 4000)
    document.addEventListener('scroll', () => {
      let currentPath = window.location.pathname;
      currentPath = currentPath.slice(4, -1);

      if (currentPath === "home" || currentPath === "hom") {
        let offset = document.getElementById("news").offsetHeight;
        if (window.scrollY > offset) {
          document.getElementById('topVideo').pause();
        }
      }
    });

  }
  render() {
    const { t } = this.props;
    const { topVideoUrl, topVideoUpdate } = this.state;
    let path = window.location.pathname
    let match = path.slice(0, 3);
    return (
      <div className={match === "/tc" ? "tc d-flex justify-content-center" : match === "/sc" ? "sc d-flex justify-content-center" : "d-flex justify-content-center"}>
        <MetaTags>
          <title>{t('home-meta-title')}</title>
          <meta name="title" content={t('home-meta-title')} />
          <meta name="description" content={t('home-meta-description')} />
          <meta name="keywords" content={t('home-meta-keywords')} />
        </MetaTags>
        <div id="home">

          <div id="intro" className="carousel" data-bs-interval="false">
            <div className="carousel-indicators">
              <button id="zero_click" type="button" data-bs-target="#intro" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
              <button id="first_click" type="button" data-bs-target="#intro" data-bs-slide-to="1" aria-label="Slide 2"></button>
            </div>
            <div className="carousel-inner">
              <div className="carousel-item active carousel-item-1">
                <div className="carousel-caption d-block p-1 p-lg-4">
                  <img src={t('header-logo')} className="carousel-logo-1" alt="" />
                  <img src={t('carousel-logo')} className="carousel-logo-2" alt="" />
                  <p className="py-4">{t('Banner msg')}</p>
                  <Link className="no_border" onClick={() => this.goToTop()} to={match + "/about"}><button className="btn btn-highlight01 px-4 py-1"><strong>{t('Learn More')}</strong></button></Link>
                </div>
              </div>
              {/* <div className="carousel-item carousel-item-2 d-flex align-items-end" >
                <div className={topVideoUpdate ? "d-none" : "d-flex justify-content-center div-btn_watch"}>
                  <button className={t('btn_watch')}><strong>{t('Watch the Full Video')}</strong></button>
                </div>
                <video autoPlay loop muted playsInline id="topVideo" type="video/mp4" className={topVideoUpdate ? "carousel-video updated" : "carousel-video"}>
                </video>
              </div> */}

              <div className="carousel-item carousel-item-2 d-flex align-items-end" onClick={() => this.updateTopVideo()}>
                <div className={topVideoUpdate ? "d-none" : "d-flex justify-content-center div-btn_watch mb-4"}>
                  <button className="btn btn-highlight01 w-100 py-1"><strong>{t('Watch the Full Video')}</strong></button>
                </div>
                <video autoPlay loop muted playsInline id="topVideo" src={topVideoUrl} type="video/mp4" className={topVideoUpdate ? "carousel-video updated" : "carousel-video"}>
                </video>
              </div>
            </div>
          </div>
          <div id="news">
            <h1 className="ps-5 pt-5 mt-5">{t('LATEST NEWS')}</h1>
            <div className="newsbox">
              <div className="newsbox-content">
                <div className="py-2">
                  <p className="newsbox-date mb-2 TXT_bold">{t('news-date-3')}</p>
                  <p className="newsbox-msg col-11">{t('news-msg-3-1')}
                    <Link onClick={() => this.goToTop()} to={match + "/conference"}>{t('news-msg-3-2')}</Link>
                    {t('news-msg-3-3')}
                    <Link onClick={() => this.goToTop()} to={match + "/awardsceremony"}>{t('news-msg-3-4')}</Link>
                    {t('news-msg-3-5')}
                    <a data-bs-toggle="modal" data-bs-target="#myModal2" role="button" className="no_border">{t('news-msg-3-6')}</a>
                    {t('news-msg-3-7')}
                  </p>
                </div>
                <div className="py-2">
                  <p className="newsbox-date mb-2 TXT_bold">{t('news-date-2')}</p>
                  <p className="newsbox-msg col-11">{t('news-msg-2-1')}</p>
                  <p className="newsbox-msg col-11">{t('news-msg-2-2')}</p>
                  <p className="newsbox-msg col-11">{t('news-msg-2-3')}<Link onClick={() => this.goToTop()} to={match + "/competition2"}>{t('news-msg-2-4')}</Link>{t('news-msg-2-5')}</p>
                </div>
                <div className="py-2">
                  <p className="newsbox-date mb-2 TXT_bold">{t('news-date-1')}</p>
                  <p className="newsbox-msg col-11">{t('news-msg-1-1')}<Link onClick={() => this.goToTop()} to={match + "/competition"}>{t('here')}</Link>{t('news-msg-1-2')}</p>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="p-4 p-sm-5">
            <div id="comp" className="d-lg-flex px-4 py-5">
              <div className="col-lg-8 text-center text-lg-start">
                <h2 className="">{t('AI COMPETITION')}</h2><br />
                <h5 className="highlight01">{t('comp-headline-date-1')}</h5>
                <h4 className="highlight01 comp-headline-date-border p-2 d-inline-block">{t('comp-headline-date-2')}</h4>
                <div className="my-4 col-lg-9 px-sm-5 px-lg-0">{t('comp-caption')}</div>
              </div>
              <div className="col-lg-4 d-flex flex-column justify-content-end align-items-center">
                <div className="col-12 d-sm-flex justify-content-between align-items-center d-lg-block px-4">
                  <div className="col-12 col-sm-6 col-lg-12">
                    <Link className="no_border d-flex justify-content-center" onClick={() => this.goToTop()} to={match + "/competition"}><button className="btn btn-highlight01 w-100 my- py-1 my-3"><strong>{t('Learn More')}</strong></button></Link>
                  </div>
                </div>
                <Timer date="5/23/2025 23:59 GMT+8" type="comp" />
              </div>
            </div>
          </div> */}
          <div id="sponsor">
            <div className="container-fluid d-flex">
              <div className="col-12 pt-5">
                <h2>{t('OUR PARTNERS')}</h2>
                <div className="mb-5">
                  <h4 className="my-5">{t('Organisers')}</h4>
                  <div className="d-flex">
                    <a href={t('org-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={org_1} className="sponsor-icon-1" alt=""></img></a>
                    <a href={t('org-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={org_2} className="sponsor-icon-1" alt=""></img></a>
                  </div>
                </div>
                <div className="mb-5">
                  <h4>{t('Advisors')}</h4>
                  <div className="d-none d-xl-block">
                    <div className="d-flex">
                      <a href={t('adv-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={adv_1} className="sponsor-icon-1" alt=""></img></a>
                      <a href={t('adv-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={adv_2} className="sponsor-icon-1" alt=""></img></a>
                      <a href={t('adv-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={adv_3} className="sponsor-icon-1" alt=""></img></a>
                    </div>
                  </div>
                  <div className="d-block d-xl-none">
                    <div className="d-flex">
                      <a href={t('adv-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={adv_1} className="sponsor-icon-1" alt=""></img></a>
                      <a href={t('adv-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={adv_2} className="sponsor-icon-1" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('adv-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={adv_3} className="sponsor-icon-1" alt=""></img></a>
                      <div className="sponsor-icon-1"></div>
                    </div>
                  </div>
                </div>
                <div className="mb-5">
                  <h4>{t('Co-Organisers')}</h4>
                  <div className="d-flex">
                    <a href={t('coorg-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={coorg_1} className="sponsor-icon-2" alt=""></img></a>
                    <a href={t('coorg-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={match === "/sc" ? coorg_2_sc : coorg_2} className="sponsor-icon-2" alt=""></img></a>
                  </div>
                </div>
                <div className="mb-5">
                  <h4>{t('Supporting Organisations')}</h4>
                  <div className="d-none d-xl-block">
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_1} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_2} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_3} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-4')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_4} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-5')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_5} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-6')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_6} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-7')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_7} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-8')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_8} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-9')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_9} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-10')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_10} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-11')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_11} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-12')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_12} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-13')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_13} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-14')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_14} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-15')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_15} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-16')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_16} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-17')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_17} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-18')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_18} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-19')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_19} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-20')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_20} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-21')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_21} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-22')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_22} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-23')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_23} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-24')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_24} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-25')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_25} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-26')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_26} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-27')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_27} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-28')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_28} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-29')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_29} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-30')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_30} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                  </div>

                  <div className="d-block d-xl-none">
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_1} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_2} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_3} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-4')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_4} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-5')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_5} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-6')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_6} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-7')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_7} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-8')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_8} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-9')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_9} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-10')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_10} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-11')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_11} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-12')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_12} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-13')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_13} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-14')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_14} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-15')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_15} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-16')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_16} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-17')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_17} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-18')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_18} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-19')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={sup_19} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-20')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_20} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-21')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_21} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-22')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_22} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-23')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_23} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-24')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_24} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-25')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_25} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-26')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_26} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-27')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_27} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-28')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_28} className="sponsor-icon-3" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('sup-link-29')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_29} className="sponsor-icon-3" alt=""></img></a>
                      <a href={t('sup-link-30')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={sup_30} className="sponsor-icon-3" alt=""></img></a>
                      <div className="sponsor-icon-3"></div>
                      <div className="sponsor-icon-3"></div>
                    </div>
                  </div>
                </div>
                <div className="mb-5">
                  <h4>{t('Titanium Sponsors')}</h4>
                  <div className="d-flex">
                    <a href={t('tit-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={tit_1} className="sponsor-icon-2" alt=""></img></a>
                  </div>
                </div>
                <div className="mb-5">
                  <h4>{t('Diamond Sponsors')}</h4>
                  <div className="d-none d-xl-block">
                    <div className="d-flex justify-content-between">
                      <a href={t('dia-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_1} className="sponsor-icon-6" alt=""></img></a>
                      <a href={t('dia-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_2} className="sponsor-icon-6" alt=""></img></a>
                      <a href={t('dia-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_3} className="sponsor-icon-6" alt=""></img></a>
                      <a href={t('dia-link-4')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_4} className="sponsor-icon-6" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('dia-link-5')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_5} className="sponsor-icon-6" alt=""></img></a>
                      <a href={t('dia-link-6')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_6} className="sponsor-icon-6" alt=""></img></a>
                      <div className="sponsor-icon-6"></div>
                      <div className="sponsor-icon-6"></div>
                    </div>
                  </div>
                  <div className="d-block d-xl-none">
                    <div className="d-flex justify-content-between">
                      <a href={t('dia-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_1} className="sponsor-icon-6" alt=""></img></a>
                      <a href={t('dia-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_2} className="sponsor-icon-6" alt=""></img></a>
                      <a href={t('dia-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={dia_3} className="sponsor-icon-6" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('dia-link-4')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={dia_4} className="sponsor-icon-6" alt=""></img></a>
                      <a href={t('dia-link-5')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={dia_5} className="sponsor-icon-6" alt=""></img></a>
                      <a href={t('dia-link-6')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={dia_6} className="sponsor-icon-6" alt=""></img></a>
                    </div>
                  </div>
                </div>
                <div className="mb-5">
                  <h4>{t('Platinum Sponsors')}</h4>
                  <div className="d-none d-xl-block">
                    <div className="d-flex justify-content-between">
                      <a href={t('plat-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={plat_1} className="sponsor-icon-4" alt=""></img></a>
                      <a href={t('plat-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={plat_2} className="sponsor-icon-4" alt=""></img></a>
                      <a href={t('plat-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={plat_3} className="sponsor-icon-4" alt=""></img></a>
                      <a href={t('plat-link-4')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={plat_4} className="sponsor-icon-4" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('plat-link-5')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={plat_5} className="sponsor-icon-4" alt=""></img></a>
                    </div>
                  </div>
                  <div className="d-block d-xl-none">
                    <div className="d-flex justify-content-between">
                      <a href={t('plat-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={plat_1} className="sponsor-icon-4" alt=""></img></a>
                      <a href={t('plat-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={plat_2} className="sponsor-icon-4" alt=""></img></a>
                      <a href={t('plat-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={plat_3} className="sponsor-icon-4" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('plat-link-4')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={plat_4} className="sponsor-icon-4" alt=""></img></a>
                      <a href={t('plat-link-5')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={plat_5} className="sponsor-icon-4" alt=""></img></a>
                      <div className="sponsor-icon-4"></div>
                    </div>
                  </div>
                </div>
                <div className="mb-5">
                  <h4>{t('Gold Sponsors')}</h4>
                  <div className="d-none d-xl-block">
                    <div className="d-flex justify-content-between">
                      <a href={t('gold-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_1} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_2} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={gold_3} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-4')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={gold_4} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-5')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={gold_5} className="sponsor-icon-5" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('gold-link-6')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_6} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-7')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={gold_7} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-8')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_8} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-9')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_9} className="sponsor-icon-5" alt=""></img></a>
                      <div className="sponsor-icon-5"></div>
                    </div>
                  </div>
                  <div className="d-block d-xl-none">
                    <div className="d-flex justify-content-between">
                      <a href={t('gold-link-1')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_1} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-2')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_2} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-3')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={gold_3} className="sponsor-icon-5" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('gold-link-4')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={gold_4} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-5')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_5} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-6')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={gold_6} className="sponsor-icon-5" alt=""></img></a>
                    </div>
                    <div className="d-flex justify-content-between">
                      <a href={t('gold-link-7')} target="_blank" rel="noopener noreferrer" className="no_border"><img src={gold_7} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-8')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_8} className="sponsor-icon-5" alt=""></img></a>
                      <a href={t('gold-link-9')} target="_blank" rel="noopener noreferrer" className="no_border"> <img src={gold_9} className="sponsor-icon-5" alt=""></img></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
          {/*  Modal */}
          <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>

                  <div className="ratio ratio-16x9">
                    <video autoPlay playsInline controls src="" id="video">
                      <source src="" type="video/mp4" />
                    </video>
                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}
                  </div>
                </div>

              </div>
            </div>
          </div>
          {/*  Modal */}
          <div className="modal fade" id="myModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content bg-black">
                <div className="modal-body">
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>

                  
                    <p>{t('alert-msg-1')}</p>
                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}
                  
                </div>

              </div>
            </div>
          </div>
        </div>

      </div >



    );
  }
}

// extended main view with translate hoc
export default translate("translations")(Home);



// WEBPACK FOOTER //
// ./src/components/pages/home.js